import { utcMoment, dateTimeFormatted } from '../utilities/dateUtils';

// Copy shown on the final result message. The fallback is used when the backend
// reports a failure without any error message of its own.
export const FORCE_ERROR_FALLBACK = 'Failed to create guarantee. Please try again or contact support.';
export const FORCE_SUCCESS_MESSAGE = 'Guarantee created successfully.';

// Fallbacks for failed requests. They are only used when the backend sends no
// message of its own — a GraphQL error message is always preferred, so a
// permission or validation failure is not hidden behind generic retry copy.
export const PRODUCTS_ERROR_FALLBACK = 'Error loading products. Please refresh the page and try again.';
export const TRANSACTIONS_ERROR_FALLBACK = 'Error looking up transactions. Please try again.';
export const EVALUATION_ERROR_FALLBACK = 'Error running eligibility checks. Please try again.';
// No blanket "try again" here: the request may have reached APMS before it
// failed, so the operator has to verify the order before forcing it once more.
export const FORCE_REQUEST_ERROR_FALLBACK = 'Error creating guarantee. Verify the order before forcing it again '
  + '— the guarantee may already exist.';

// Loader copy for the two long-running steps of the flow.
export const SEARCHING_TRANSACTIONS_MESSAGE = 'Searching transactions...';
export const RUNNING_ELIGIBILITY_MESSAGE = 'Running eligibility checks...';

// Onboarding copy shown until the first search is performed.
export const INSTRUCTIONS_HEADER = 'Force Guarantee';
export const INSTRUCTIONS_STEPS = [
  'Select a product to define which eligibility rules apply. Look up the vehicle by VIN to load its transactions.',
  'Select a transaction from the list.',
  'Run the eligibility check and review the full results log, including the rules that failed.',
  'Confirm with a justification to force-create the guarantee even when eligibility rules fail.',
];

// Backend timestamps come back as UTC ISO strings; render them the same way as
// the other transaction tables in the app.
const formatTimestamp = value => (value ? dateTimeFormatted(utcMoment(value)) : '—');

// Columns of the transaction list. `key` is a field of
// `guaranteeForceOrdersQuery`, the optional `format` transforms the raw value
// before it is rendered. The table renders straight from this list.
export const TRANSACTION_COLUMNS = [
  { key: 'orderId', label: 'Order ID' },
  { key: 'vin', label: 'VIN' },
  { key: 'sellerAccountNumber', label: 'Seller (5M)' },
  { key: 'productOrderState', label: 'Order State' },
  { key: 'ineligibilityType', label: 'Ineligibility Type' },
  { key: 'createdAt', label: 'Created At', format: formatTimestamp },
  { key: 'updatedAt', label: 'Updated At', format: formatTimestamp },
];
